import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';

const initialState = {
  fieldOfficers: [],
  status: 'idle',
  error: null,
};

export const fetchFieldOfficersByAdminId = createAsyncThunk(
  'super-admin/fetchFeildOfficersByAdmin',
  async ({ admin_id }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/super-admin/${admin_id}/field-officers`);
      return data;
    } catch (err) {
      return rejectWithValue(err.response.data.msg);
    }
  }
);

export const fieldOfficersByPartnerSlice = createSlice({
  name: 'fieldOfficersByPartner',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchFieldOfficersByAdminId.pending, (state, action) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchFieldOfficersByAdminId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // Safety check: ensure fieldOfficers exists before spreading
        state.fieldOfficers = action.payload?.fieldOfficers ? [...action.payload.fieldOfficers] : [];
      })
      .addCase(fetchFieldOfficersByAdminId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'An error occured';
      });
  },
});

export default fieldOfficersByPartnerSlice.reducer;
